import { render, staticRenderFns } from "./ResourceShowWrapper.vue?vue&type=template&id=334db336&scoped=true&"
import script from "./ResourceShowWrapper.vue?vue&type=script&lang=js&"
export * from "./ResourceShowWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ResourceShowWrapper.vue?vue&type=style&index=0&id=334db336&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334db336",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
